import React, { useState, useEffect } from 'react';
import { Grid } from "@mui/material";
import clsx from 'clsx';
import logoImg from "../../../../assets/images/logo.png";
import hamburger from "../../../../assets/images/hamburger.svg";
import customStyles from "../../../../assets/styles/customStyles";
import { Menus } from "./Menus";
import { Image } from 'antd';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";


export const Navbar = (props) => {
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
    const { subscriptionDetails } = useSelector(state => state.homeReducer);
    const [days, setDays] = useState(0);

    useEffect(() => {
        if (subscriptionDetails?.subscriptionEndDate) {
            let date1 = new Date();
            let date2 = new Date(subscriptionDetails?.subscriptionEndDate);
            let Difference_In_Time = date2.getTime() - date1.getTime();
            setDays(Math.round(Difference_In_Time / (1000 * 3600 * 24)));
        }
    }, [subscriptionDetails]);


    const classes = customStyles();
    return (
        <Grid item xs={12} className={clsx(classes.header, { [classes.none]: props?.type === 'StoreSalesCreate' || props?.Component?.name === 'Pfe' })}>
            <Link to={'/'} tabIndex={-1} className={clsx(classes.disInline, classes.headerLogo)}>
                <Image
                    preview={false}
                    className={clsx(classes.margin10tb, classes.logoImg)}
                    src={logoImg}
                />
            </Link>
            {
                subscriptionDetails?.subscriptionEndDate && days <= 7 && days !== 0 && <div className={classes.subscriptionExpired}>
                    {
                        days < 0 ? <span>{`Your plan has been expired`}</span> : <span>{`Your plan expires in ${days} days`}</span>
                    }
                    <Link to="/admin/home/billings" tabIndex={-1} className={classes.modalBtn}>Upgrade</Link>
                </div>
            }
            <Menus {...props} handleClose={() => setMobileMenuVisible(false)} mobileMenuVisible={mobileMenuVisible} />

            <Link to={'#'} className={classes.mobileBurgerIcon} onClick={() => setMobileMenuVisible(true)}>
                <Image preview={false} src={hamburger} />
            </Link>
        </Grid>
    )
}